module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//17.jpg?457f8625ae1a647402bf326142b38186";